export default __webpack_public_path__ + "static/media/platipus.e5e2c033.svg";